module.exports = __webpack_public_path__ + "media/images/pc/accessories/men/men_04-b7926a5d64ba89fccee8d5dba09d5f1e.jpg";